import { useQuery } from 'react-query';
import { useCustomerContext } from 'contexts/Customer';
import { useDarkstoreContext } from 'contexts/Darkstore';
import api from 'utils/api';
import { sortByZeroQty } from 'utils/helpers';
import { mapProducts } from 'utils/mappers';

const getSpecialProducts = async ({ darkstoreId, isAuthenticated }) => {
  const products = await api.get(`products/main/${darkstoreId}`);

  let favorites = [];

  if (isAuthenticated) {
    favorites = await api.get(`/products/favourite/list/${darkstoreId}`);
  }

  const remappedProducts = mapProducts(products).map(product => ({
    ...product,
    isFavorite: favorites.some(favorite => favorite.id === product.id),
  }));

  return sortByZeroQty(remappedProducts);
};

const useSpecialProducts = () => {
  const { darkstoreId } = useDarkstoreContext();

  const { isAuthenticated } = useCustomerContext();

  const { data: products = [], ...rest } = useQuery(
    ['catalog/special', { darkstoreId, isAuthenticated }],
    () => getSpecialProducts({ darkstoreId, isAuthenticated }),
  );

  return { products, ...rest };
};

export default useSpecialProducts;
